<script lang="ts" setup>
import AppFooter from './AppFooter.vue'
import AppTopbar from './AppTopbar.vue'
</script>

<template>
  <div class="bg-surface-0 dark:bg-surface-900">
    <div class="landing-wrapper overflow-hidden">
      <app-topbar></app-topbar>
      <div class="mx-0 lg:mx-20">
        <nuxt-page />
      </div>
      <div class="mx-0 lg:mx-20">
        <app-footer></app-footer>
      </div>
    </div>
  </div>
  <ConfirmDialog />
  <DynamicDialog />
  <Toast />
</template>
